export default "__VITE_ASSET__0xtCbM5a__"